<template>
  <div id="default-content">content here...</div>
</template>

<script>
export default {
  name: "default_content_modal",
};
</script>